import { useApiKeys, usePrincipals } from 'hooks/queries';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { APIGeneratorModal } from '../../../components/ApiKeyManagement/APIGeneratorModal';
import { APIKeyTransferModal } from '../../../components/ApiKeyManagement/APIKeyTransferModal';
import { Button } from '../../../components/Button';
import { Heading } from '../../../components/Heading';

import { Tab } from '../../../components/Tabs';
import { Tabs } from '../../../components/Tabs/Tabs';
import { APIKeyHistory } from '../APIKeyHistory/APIKeyHistory';
import { APIKeyOverview } from '../APIKeyOverview/APIKeyOverview';
import { getCurrentPrincipal } from '../../../lib/currentPrincipal';
import { trackPageViewed } from '../../../utils/principal-service/event-endpoints';

export const APIKeyGenerator: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('key overview');
  const { t } = useTranslation();
  const { data: principals } = usePrincipals();
  const { currentPrincipal } = getCurrentPrincipal(principals);
  const [showAPIGeneratorModal, setShowAPIGeneratorModal] = useState(false);
  const {
    areAvailableKeysLoading,
    apiKeys,
    apiHistoryWithAdditions,
    isApiKeyHistoryWithAdditionsLoading,
  } = useApiKeys();

  const onCancel = () => {
    setShowAPIGeneratorModal(false);
  };

  useEffect(() => {
    trackPageViewed({
      principalId: currentPrincipal.id,
      content: 'API Key Generator',
      section: activeTab,
    });
  }, [activeTab, currentPrincipal.id]);

  return (
    <>
      <div className="max-w-xl-content xl:min-w-content mx-auto mb-7 space-y-5 px-4 pt-6 md:mb-9 md:px-6 md:pt-7">
        <div className="space-y-4">
          <Heading
            text={t(`features:collaboration:apiKeyGenerator:heading`)}
            margin={0}
            level="h1"
          />
          <div className="text-grey-700 mt-1 w-3/4 ">
            {t(`features:collaboration:apiKeyGenerator:description`)}
          </div>
        </div>
        <Tabs activeTab={activeTab} onTabChange={setActiveTab}>
          <Tab
            title={t(
              `features:collaboration:apiKeyGenerator:tabs:key-overview`,
            )}
            tabKey="key overview"
            key="key overview"
          >
            <div className="mb-5 flex items-center justify-between">
              <div>
                <Heading
                  text={t(
                    `features:collaboration:apiKeyGenerator:keyOverview:projects`,
                  )}
                  margin={0}
                  level="h3"
                />
              </div>
              {!!apiKeys?.length && (
                <div>
                  <Button onClick={() => setShowAPIGeneratorModal(true)}>
                    {t(
                      `features:collaboration:apiKeyGenerator:keyOverview:buttonText`,
                    )}
                  </Button>
                </div>
              )}
            </div>
            <APIKeyOverview
              areAvailableKeysLoading={areAvailableKeysLoading}
              apiKeys={apiKeys}
              handleShowAPIGeneratorModal={() => setShowAPIGeneratorModal(true)}
              module="apiKeyGenerator"
              tab="keyOverview"
            />
          </Tab>
          <Tab
            title={t(`features:collaboration:apiKeyGenerator:tabs:key-history`)}
            tabKey="key history"
            key="key history"
          >
            <APIKeyHistory
              module="apiKeyGenerator"
              apiHistory={apiHistoryWithAdditions}
              isApiKeyHistoryLoading={isApiKeyHistoryWithAdditionsLoading}
            />
          </Tab>
        </Tabs>
      </div>
      {showAPIGeneratorModal && (
        <APIGeneratorModal
          onCancel={onCancel}
          onConfirmAPICopy={() => setShowAPIGeneratorModal(false)}
        />
      )}
      <APIKeyTransferModal />
    </>
  );
};
